export const shortenAddress = (address, startChars = 6, endChars = 4) => {
    if (!address) return '';
    const start = address.slice(0, startChars);
    const end = address.slice(-endChars);
    return `${start}...${end}`;
};

/**
 * Format date/time the same as the Deals table: exact stored time (no timezone shift), AM/PM.
 * Handles "YYYY-MM-DD HH:MM:SS", "YYYY-MM-DDTHH:MM:SS", and date-only "YYYY-MM-DD".
 * Returns "MM/DD/YYYY, HH:MM AM/PM" or "MM/DD/YYYY" for date-only.
 */
export const formatDateTimeAsStored = (dateString) => {
    if (dateString == null || dateString === '') return 'N/A';
    const dateStr = String(dateString);
    // Full datetime: "2023-02-14 15:33:22+05:30" or "2023-02-14T15:33:22.000Z"
    const match = dateStr.match(/(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2}):(\d{2})/);
    if (match) {
        const [, year, month, day, hourStr, minute] = match;
        let hours = parseInt(hourStr, 10);
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours || 12;
        const formattedHours = String(hours).padStart(2, '0');
        return `${month}/${day}/${year}, ${formattedHours}:${minute} ${ampm}`;
    }
    // Date only: "2023-02-14"
    const dateOnly = dateStr.match(/(\d{4})-(\d{2})-(\d{2})/);
    if (dateOnly) {
        const [, year, month, day] = dateOnly;
        return `${month}/${day}/${year}`;
    }
    return 'N/A';
};